import React, { useState } from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ServiceFilter = ({
  selected,
  setSelected,
  dataList = [],
  isLoading,
  style,
  isError,
  isRequired,
  startAdornment,
  ...props
}) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  return (
    <Autocomplete
      {...props}
      disablePortal
      loading={isLoading}
      loadingText={t("Loading...")}
      id="combo-box-demo"
      size="small"
      className={props.className || "w-full"}
      value={selected}
      onChange={(event, object) => {
        object ? setSelected(object) : setSelected(null);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      options={dataList.map((el) => ({
        label: el?.name,
        id: el?.id,
      }))}
      noOptionsText={`${t("NoServiceFound")}`}
      filterOptions={(options, { inputValue }) => {
        return options?.filter((item) =>
          item?.label?.toLowerCase().includes(inputValue.toLowerCase())
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={isError}
          helperText={isError}
          required={isRequired}
          label={t("SearchService")}
          placeholder={t("WhriteServiceName")}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? (
                  <CircularProgress style={{ color: colorPrimary }} size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
            startAdornment: startAdornment,
          }}
        />
      )}
    />
  );
};

export default ServiceFilter;
